export const FETCH_DISCREPANCY = "app/DISCREPANCY/FETCH_DISCREPANCY";
export const FETCH_DISCREPANCY_SUCCESS =
  "app/DISCREPANCY/FETCH_DISCREPANCY_SUCCESS";
export const FETCH_DISCREPANCY_FAILURE =
  "app/DISCREPANCY/FETCH_DISCREPANCY_FAILURE";
export const UPDATE_LIST = "app/DISCREPANCY/UPDATE_LIST";

export const UPDATE_FILTERS = "app/DISCREPANCY/UPDATE_FILTERS";
export const UPDATE_WEEK = "app/DISCREPANCY/UPDATE_WEEK";
export const TOGGLE_MODAL = "app/DISCREPANCY/TOGGLE_MODAL";
export const TOGGLE_UNAPPROVE = "app/DISCREPANCY/TOGGLE_UNAPPROVE";

export const APPROVE_CLOCK = "app/DISCREPANCY/APPROVE_CLOCK";
export const APPROVE_CLOCK_SUCCESS = "app/DISCREPANCY/APPROVE_CLOCK_SUCCESS";
export const APPROVE_CLOCK_FAILURE = "app/DISCREPANCY/APPROVE_CLOCK_FAILURE";
